import ResultsServiceModel from '../ResultsServiceModel'

export default class ResultModel extends ResultsServiceModel {
  modelName () {
    return 'results'
  }

  // Route configuration
  routes() {
    return _.merge(
      super.routes(),
      {
        download: process.env.VUE_APP_RESULTS_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/modus/{id}'
      }
    )
  }

  defaults () {
    return {
      id: null,
      lims_id: null,
      fmis_id: null,
      laboratory_id: null,
      sample_type_id: null,
      customer_id: null,
      customer_fmis_id: null,
      customer_number: null,
      customer_name: null,
      customer_company: null,
      grower: null,
      field: null,
      zone: null,
      irrigated: null,
      storage_bin: null,
      crop_type: null,
      crop_stage: null,
      received_at: null,
      processed_at: null,
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }

  mutations () {
    return {
      id: val => this.nullStringMutator(val),
      lims_id: val => this.nullStringMutator(val),
      fmis_id: val => this.nullStringMutator(val),
      laboratory_id: val => this.nullStringMutator(val),
      sample_type_id: val => this.nullStringMutator(val),
      customer_id: val => this.nullStringMutator(val),
      customer_fmis_id: val => this.nullStringMutator(val),
      customer_number: val => this.nullStringMutator(val),
      customer_name: val => this.nullStringMutator(val),
      customer_company: val => this.nullStringMutator(val),
      grower: val => this.nullStringMutator(val),
      field: val => this.nullStringMutator(val),
      zone: val => this.nullStringMutator(val),
      irrigated: val => this.nullStringMutator(val),
      storage_bin: val => this.nullStringMutator(val),
      crop_type: val => this.nullStringMutator(val),
      crop_stage: val => this.nullStringMutator(val),
      received_at: val => this.nullStringMutator(val),
      processed_at: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val)
    }
  }

  getModus () {
    let method = this.getMethod('fetch')
    let route = this.getRoute('download')
    let url = this.getURL(route, {
      id: this.get(this.getOption('identifier'))
    })

    return this.createRequest({ method, url }).send()
  }
}
